import _extends from "@babel/runtime/helpers/extends";
import React, { useState, useEffect, forwardRef, useImperativeHandle, useRef } from 'react';
import { cls } from '@arco-design/mobile-utils';
import { ContextLayout } from '../context-provider';
export var CheckboxGroupContext = /*#__PURE__*/React.createContext({
  isGroup: false,
  shape: 'circle',
  layout: 'inline',
  disabled: false,
  value: [],
  onChange: function onChange() {}
});
export function componentGenerator(Comp) {
  return /*#__PURE__*/forwardRef(function (props, ref) {
    var _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        _props$className = props.className,
        className = _props$className === void 0 ? '' : _props$className,
        _props$defaultValue = props.defaultValue,
        defaultValue = _props$defaultValue === void 0 ? [] : _props$defaultValue,
        _props$disabled = props.disabled,
        disabled = _props$disabled === void 0 ? false : _props$disabled,
        _props$shape = props.shape,
        shape = _props$shape === void 0 ? 'circle' : _props$shape,
        options = props.options,
        icons = props.icons,
        onChange = props.onChange,
        value = props.value,
        _props$children = props.children,
        children = _props$children === void 0 ? null : _props$children,
        _props$layout = props.layout,
        layout = _props$layout === void 0 ? 'inline' : _props$layout,
        _props$min = props.min,
        min = _props$min === void 0 ? 0 : _props$min,
        _props$max = props.max,
        max = _props$max === void 0 ? 0 : _props$max;

    var _useState = useState(value || defaultValue),
        groupValue = _useState[0],
        setGroupValue = _useState[1];

    var domRef = useRef(null);
    useImperativeHandle(ref, function () {
      return {
        dom: domRef.current
      };
    });
    useEffect(function () {
      value !== void 0 && setGroupValue(value);
    }, [value]);
    /**
     * 切换checkbox状态回调
     * @en callback when toggling checkbox state
     */

    var handleChange = function handleChange(checked, val) {
      if (!checked && groupValue.length <= min || max && checked && groupValue.length >= max) return;
      var newGroupValue = checked ? [].concat(groupValue, [val]) : groupValue.filter(function (item) {
        return item !== val;
      });
      onChange && onChange(newGroupValue);

      if (value === void 0) {
        setGroupValue(newGroupValue);
      }
    };

    return /*#__PURE__*/React.createElement(ContextLayout, null, function (_ref) {
      var prefixCls = _ref.prefixCls;
      return /*#__PURE__*/React.createElement("div", {
        ref: domRef,
        style: style,
        className: cls(className, prefixCls + "-checkbox-group")
      }, /*#__PURE__*/React.createElement(CheckboxGroupContext.Provider, {
        value: {
          isGroup: true,
          shape: shape,
          layout: layout,
          disabled: disabled,
          icons: icons,
          value: groupValue,
          onChange: handleChange
        }
      }, children, !children && options && options.map(function (option) {
        return /*#__PURE__*/React.createElement(Comp, _extends({
          key: option.value
        }, option));
      })));
    });
  });
}